import BaseAction from './BaseAction.js';
import Track from 'track/Track.js';
import StepData from 'pattern/StepData.js';
import StepBucket from 'pattern/StepBucket.js';

class ToggleStepAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({track, steps, stepNumber, resolution=Track.baseResolution}, updateRedux=true) {
        if (track === undefined) {
            return {steps: []};
        }
        if (track.instrumentTrack) {
            track = track.instrumentTrack;
        }
        let pattern = track.getEasyPattern();
        let stepResolutionTree = pattern.pattern.getStepResolutionTree(resolution.isTriplet);
        let node = stepResolutionTree.search(stepNumber, resolution);
        let ret = node.toggle(steps && steps[0] ? steps[0].stepBucket.steps[0].id : undefined);

        track.pattern.syncMatrix();
        if (updateRedux) {
            track.pattern.syncBucketsAtStep(stepNumber, resolution);
            track.updateSteps(undefined, true);
        }
        track.pattern.needsSync = true;

        return {steps: ret};
    }

    undo(action) {
        let pattern = action.payload.track.getEasyPattern();
        if (action.payload.steps !== undefined) {
            // then we need to add these back
            let stepBuckets = action.payload.resolution.isTriplet ?
                pattern.pattern.tripletStepBuckets :
                pattern.pattern.stepBuckets;
            for (let i in action.payload.steps) {
                let step = action.payload.steps[i];
                stepBuckets[step.stepNumber] = step.stepBucket;
            }
        } 

        pattern.update(action.payload.resolution.isTriplet);
        action.payload.track.updateSteps();
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let operation = json.operation;
        if (operation.payload.steps) {
            operation.payload.steps = operation.payload
                .steps.map(
                    s => ({
                        ... s,
                        stepBucket: s.stepBucket.getJson()
                    }));
        }
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let payload = action.payload;
        if (payload.track === undefined) {
            // track did not exist
            return undefined;
        }

        let {track} = payload;

        let steps = [];
        if (json.payload.steps) {
            for (let i in json.payload.steps) {
                let {stepBucket, stepNumber} = json.payload.steps[i];
                let stepBucketObject = new StepBucket(track, stepBucket.isTriplet);
                for (let key in stepBucket) {
                    let stepJson = stepBucket[key];
                    let stepData = new StepData();
                    stepData.track = track;
                    stepData.stepNumber = stepNumber;
                    stepData.loadFromJson(
                        stepJson,
                        track.effects,
                        undefined,
                        undefined,
                        undefined,
                        track,
                        track.midiEffects);
                    stepData.id = stepJson.id;
                    stepBucketObject.steps[key] = stepData;
                }
                steps.push({stepNumber, stepBucket: stepBucketObject});
            }
        }
        payload.steps = steps;
        return action;
    }

    getContentId(action) {
        return action.payload.steps[0].id;
    }
}

export default ToggleStepAction;
